import { render } from "./BandFilter.vue?vue&type=template&id=d07bab86&scoped=true&ts=true"
import script from "./BandFilter.vue?vue&type=script&lang=ts"
export * from "./BandFilter.vue?vue&type=script&lang=ts"

import "./BandFilter.vue?vue&type=style&index=0&id=d07bab86&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d07bab86"]])

export default __exports__